// extracted by mini-css-extract-plugin
module.exports = {"canvasWrapper":"_1XDdfmrfxTzo2VGTyWJ7m8","canvas":"_1ZZ98UcbrobcAAITLz0uMR","canvasVertical":"_3kizEawXMQG61lGxZlvn76","canvasHorizontal":"_34HLUl_I454KQM9oLHI6rZ"};